import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  accordion: css`
    border-radius: 30px !important;
    border: 2.5px solid #0045b5;
    box-shadow: none;
    min-height: 70px;

    overflow: hidden;

    &::before {
      display: none;
    }

    @media (max-width: 399px) {
      border-radius: 20px !important;
    }
  `,
  accordion__summary: css`
    flex-direction: row-reverse;
    gap: 16px;
    min-height: 70px;

    & .MuiAccordionSummary-expandIconWrapper {
      align-self: flex-start;
      margin-top: 18px;

      ${theme.breakpoints.down("md")} {
        margin-top: 22px;
      }
    }
  `,
  acortion__answer: css`
    word-break: break-word;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    text-align: left;
    ul,
    ol {
      padding-inline-start: 20px;
    }
    a {
      color: ${theme.palette.info.main};
      word-break: break-word;
    }
  `
};
